// @flow

import { CLUSTER_USAGE_TAB_KEYS } from '../cluster/cluster-monthly-inputs/constants';
import { ESTIMATE_ACCORDION_KEYS } from '../estimate-top-level/constants';

export const FEDRAMP_ENABLED_BACKEND_NAME = 'fedramp_enabled';
export const FEDRAMP_ENABLED_DISPLAY_NAME = 'FedRAMP';

export const FEDRAMP_SUPPORTED_ESTIMATE_ACCORDION_KEYS = [
  ESTIMATE_ACCORDION_KEYS.ESTIMATE_DETAILS,
  ESTIMATE_ACCORDION_KEYS.PREVIOUS_CONTRACT_DETAILS,
  ESTIMATE_ACCORDION_KEYS.CUSTOM_DISCOUNTS,
  ESTIMATE_ACCORDION_KEYS.CREDITS_AND_BURSTS,
  ESTIMATE_ACCORDION_KEYS.CLUSTERS_SUMMARY,
  ESTIMATE_ACCORDION_KEYS.ESTIMATE_SUMMARY,
];

export const FEDRAMP_SUPPORTED_CLUSTER_USAGE_TAB_KEYS = [CLUSTER_USAGE_TAB_KEYS.THROUGHPUT];
